
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.92.192a.8.8 0 00-1.04 0l-.072.062c-.044.04-.107.095-.186.168a27.406 27.406 0 00-2.64 2.77c-.72.875-1.458 1.898-2.017 2.977C2.409 7.241 2 8.422 2 9.6a6.4 6.4 0 0012.8 0c0-1.178-.409-2.359-.965-3.43-.56-1.08-1.296-2.103-2.017-2.979a27.4 27.4 0 00-2.64-2.77L8.922.193zM3.6 9.6c0-.822.291-1.742.785-2.694.49-.946 1.154-1.873 1.833-2.698A25.806 25.806 0 018.4 1.881a25.801 25.801 0 012.182 2.327c.68.825 1.342 1.752 1.833 2.698.494.952.785 1.872.785 2.694a4.8 4.8 0 01-9.6 0z","fill":"#718096"}}),_c('path',{attrs:{"d":"M5.488 9.633a.8.8 0 00-.539.995 3.606 3.606 0 002.423 2.423.8.8 0 00.456-1.534 2.006 2.006 0 01-1.345-1.345.8.8 0 00-.995-.539z","fill":"#718096"}})])
          )
        }
      }
    